import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc, bscTestnet } from '@reown/appkit/networks';

export const projectId = '4f686ff43f8451a2515b861a9e52adb4';

export const networks = [
  {
    ...bsc,
    rpcUrls: {
      default: { 
        http: [
          'https://rpc.ankr.com/bsc/55bc2f56a8642e8d1641babfd599e3e3a1c0279e5ac23f88aed78da311a52452',
          'https://bsc-dataseed.binance.org/'
        ] 
      },
    },
  },
  bscTestnet 
];

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false
});

export const config = wagmiAdapter.wagmiConfig;

// KARENA SEKARANG 1 CONTRACT, ISI KEDUA VARIABEL INI DENGAN ALAMAT YANG SAMA NANTINYA
export const AIRDROP_CONTRACT = "0xe6651cEcDa15087E361B63016e6d23A2E15D2E00";
export const TOKEN_CONTRACT = "0xe6651cEcDa15087E361B63016e6d23A2E15D2E00";

// ABI diperbarui untuk menambahkan fungsi 'swap'
export const airdropABI = [
  {
    "inputs": [{ "internalType": "address", "name": "ref", "type": "address" }],
    "name": "claimAirdrop",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "address", "name": "inviter", "type": "address" }],
    "name": "swap",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
];